import { Box } from '@mui/material';
import { Card, CardTitle } from '@apigrowfinance/pbolt-card';
import IllustratedMessage from '@apigrowfinance/pbolt-illustrated-message';
import { RiFundsLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import CardsListRow from '@components/accountCardControlDetails/cardsBlock/CardsListRow';
import { useAccount } from '@contexts/AccountProvider';
import useGetCustomerCards from '@hooks/queries/useGetCustomerCards';

interface CardsBlockProps {
    cardIDsWithFlexControls?: number[];
}
const CardsBlock = ({ cardIDsWithFlexControls }: CardsBlockProps) => {
    const { customerId } = useParams();
    const { account } = useAccount();

    const { data: cardsData, isLoading } = useGetCustomerCards(
        account?.account_id,
        parseFloat(customerId),
    );
    const filteredCards = cardsData?.filter((card) =>
        cardIDsWithFlexControls?.includes(card?.id),
    );

    if (!isLoading && filteredCards?.length === 0) {
        return (
            <Card>
                <Box data-testid="no-cards-block">
                    <IllustratedMessage
                        icon={<RiFundsLine />}
                        messageMain={
                            <FormattedMessage
                                id="CardsBlock.noCardTitle"
                                defaultMessage="No cards found"
                            />
                        }
                        messageSub={
                            <FormattedMessage
                                id="CardsBlock.noControlsDescription"
                                defaultMessage="There are no cards associated with this flex control"
                            />
                        }
                    />
                </Box>
            </Card>
        );
    }

    return (
        <Card isBottomRadiusBorder={false} isIndented>
            <CardTitle isLoading={isLoading}>
                <FormattedMessage
                    id="CardsBlock.cards"
                    defaultMessage="Cards"
                />
            </CardTitle>
            {filteredCards?.map((card) => {
                return (
                    <CardsListRow
                        card={card}
                        isLoading={isLoading}
                        key={card.id}
                    />
                );
            })}
        </Card>
    );
};

export default CardsBlock;
